import Image from 'next/image';
import Cookies from 'js-cookie';

import { Box, Button, ButtonGroup, Divider, Heading, Modal, Paragraph } from '@zillow/constellation-10';

import { SPOTLIGHT_LISTINGS_COOKIES } from '../../../../srcLegacy/shared/constants/CookieConstants';

import SellHomeSVG from '../../../assets/sell-home.svg';

const SPOTLIGHT_ADVERTISING_URL =
  '/rentals-network/advertise-zillow-rentals-zram/?utm_source=zram&utm_medium=onsite&utm_campaign=listing_spotlight_zram&utm_content=mf_rentals_contact_sales';

const SpotlightListingsFirstUseModal = ({ onClose }: { onClose: () => void }) => {
  const handleClose = () => {
    Cookies.set(SPOTLIGHT_LISTINGS_COOKIES.HAS_CLOSED_SPOTLIGHT_LISTINGS_MODAL, 'true', {
      expires: SPOTLIGHT_LISTINGS_COOKIES.EXPIRATION,
    });
    onClose();
  };

  return (
    <Modal.Root
      open={true}
      onOpenChange={(open: boolean) => {
        if (!open) {
          handleClose();
        }
      }}
      size={{ base: 'fullScreen', md: 'md' }}
      useDismissProps={{ outsidePress: false }}
    >
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content data-panda-theme="zillow" css={{ paddingBlockStart: '0 !important', overflow: 'hidden' }}>
            <Modal.Body css={{ padding: '0 !important' }}>
              <Box css={{ position: 'relative' }}>
                <Image src={SellHomeSVG} alt="A person standing near a house" />
                <Modal.CloseButton css={{ position: 'absolute', top: '200', right: '200' }} />
              </Box>
              <Box css={{ padding: '400' }}>
                <Heading level={2} textStyle="heading-sm">
                  Spotlight what matters most
                </Heading>
                <Paragraph css={{ marginBlock: '400' }}>
                  <strong>Listing Spotlight</strong> gives your single-family listings on average{' '}
                  <strong>2x more exposure than Feed Connect listings</strong>, according to Zillow internal data.
                  Simply add Listing Spotlight to an eligible property that needs a lift, and reassign it when you’ve
                  filled that vacancy.
                </Paragraph>
              </Box>
            </Modal.Body>
            <Divider />
            <Modal.Footer>
              <ButtonGroup aria-label="Actions">
                <Button
                  tone="brand"
                  emphasis="outlined"
                  onClick={() => {
                    handleClose();
                  }}
                  asChild
                >
                  <a target="_blank" rel="noopener noreferrer" href={SPOTLIGHT_ADVERTISING_URL}>
                    Learn more
                  </a>
                </Button>
                <Button
                  tone="brand"
                  emphasis="filled"
                  onClick={() => {
                    handleClose();
                  }}
                  asChild
                >
                  <a target="_blank" rel="noopener noreferrer" href={SPOTLIGHT_ADVERTISING_URL}>
                    Get Listing Spotlight
                  </a>
                </Button>
              </ButtonGroup>
            </Modal.Footer>
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
};

export default SpotlightListingsFirstUseModal;
